export default __webpack_public_path__ + "static/media/gallery_03.8de43e07.jpg";